import React from "react";
import ColumnRules from "./ColumnRules";


const ImportInviteColumnRules = () => {
  const rules = [
    {
      name: "name",
      required: true,
      options: ["Nome do processo de convocação."],
    },
    {
      name: "start_at",
      required: true,
      options: ["Início em."],
    },
    {
      name: "end_at",
      required: true,
      options: ["Término em."],
    },
    {
      name: "email_message",
      required: true,
      options: ["Corpo do e-mail."],
    },
    {
      name: "onboarding",
      required: true,
      options: ["Processo de matrícula."],
    },
    {
      name: "email_header",
      required: true,
      options: ["Cabeçalho do e-mail."],
    },
    {
      name: "require_term_of_absence",
      required: true,
      options: ["Requer termo de falsa."],
    },
    {
      name: "extra_limit_days",
      required: true,
      options: ["Prazo extra em dias."],
    },
  ];

  return <ColumnRules rules={rules} />;
};

export default ImportInviteColumnRules;
